import React from 'react';
import { companiesCommand_patchAddress, IAddressModel, ICompany } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import { AddressForm } from 'shared/address/AddressForm';

interface IProps {
	company: ICompany;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

const toModel = (supplier: ICompany): IAddressModel => {
	return {
		addressLine: supplier.addressLine ?? '',
		zip: supplier.zip ?? '',
		city: supplier.city ?? '',
		country: supplier.country,
	};
};

export const PatchCompanyAddressForm = ({ company, confirm, cancel }: IProps) => {
	const strings = useLocalization();

	return (
		<AddressForm
			open
			submitFunction={model => companiesCommand_patchAddress({ vatCustomerId: company.id, address: model })}
			cancel={cancel}
			model={toModel(company)}
			successMessage={strings.addressUpdated}
			confirm={confirm}
		/>
	);
};
